import React from 'react';

import { useUploadDetections } from '../../../../../../hooks';
import { AddDetectionUpload, ActiveDetectionUpload } from './components';
import { progressBarHeight } from '../../../constants';

/**
 * Allows the user to upload detection files from an external source to set up a Gap Analysis
 * report. The user does not have to take this step; they can also choose to use internal Trqk
 * detection data if it is available.
 * @param props - {@link GapAnalysisStepProps}
 */
export const UploadDetections: GapAnalysisStepComponent = props => {
    const { context, remove, send, stepId } = props;
    const { inProgressTasks } = useUploadDetections();

    if (inProgressTasks.length > 0) {
        return (
            <ActiveDetectionUpload
                context={context}
                height={progressBarHeight}
                inProgressTasks={inProgressTasks}
                remove={remove}
                send={send}
            />
        );
    }

    return (
        <AddDetectionUpload
            context={context}
            remove={remove}
            send={send}
            stepId={stepId}
        />
    );
};
